import React from 'react'
import { Link } from 'react-router-dom'

function AdminDashboardBreadCrumb() {
    return (
        <Link to="/admin/dashboard">Dashboard</Link>
    )
}

export default AdminDashboardBreadCrumb